var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from 'clsx';
import { TagGroupCore } from '@core-front/tag-group';
import Tag from '@telia-front/tag';
const TagGroup = (props) => {
    const { tags } = props, rest = __rest(props, ["tags"]);
    const getPurpose = (purpose) => {
        switch (purpose) {
            case 'primary':
                return purpose;
            default:
                return undefined;
        }
    };
    const getSize = () => {
        if (props.size !== 'icon') {
            return props.size;
        }
    };
    const getTags = () => {
        return tags.map((tag) => {
            const { purpose } = tag, others = __rest(tag, ["purpose"]);
            return Object.assign(Object.assign({}, others), { className: clsx({
                    [`telia-tag--${tag.purpose}`]: tag.purpose && getPurpose(tag.purpose) === undefined,
                    ['telia-tag--icon']: props.size === 'icon',
                }, tag.className), purpose: getPurpose(purpose), size: getSize() });
        });
    };
    return (React.createElement(TagGroupCore, Object.assign({}, rest, { components: {
            Tag,
        }, size: getSize(), tags: getTags() })));
};
export { TagGroup as default };
